//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "AQSkeleton",
    props: {
        type: { type: String, default: "oneLineCards" },
        numberOfItems: { type: Number, default: 1 },
        customHeight: { type: Number, default: 0 },
        customWidth: { type: Number, default: 0 }

    },
    data() {
        return {};
    },
    computed: {
        squareCards() {
            return this.type === "oneLineCards" || this.type === "multipleSmallCards";
        },
        styleSquareObject() {
            let height = "";
            if (this.customHeight) {
                height = `${this.customHeight}px`;
            } else {
                height = this.type === "oneLineCards" ? "100%" : "61px";
            }
            const styleToReturn = {
                height
            };
            if (this.type === "multipleSmallCards") {
                styleToReturn.width = this.customWidth ? `${this.customWidth}px` : "58px";
            }

            return styleToReturn;
        },
        styleFlatObject() {
            const defaultHeight = this.type === "flatCards" ? "40px" : "64px";
            return {
                height: this.customHeight ? `${this.customHeight}px` : defaultHeight
            };
        }
    },
    methods: {
        bindingClasses(index) {
            let addMargin = false;
            if ((this.type === "oneLineCards" && index < this.numberOfItems - 1)
                || (this.type === "multipleSmallCards" && index < this.numberOfItems - 1 && (index + 1) % 3 !== 0)) {
                addMargin = true;
            }

            return {
                "q-mr-md": addMargin,
                "full-width": this.numberOfItems === 1,
                "flex-class": this.type === "oneLineCards",
                "q-mb-sm": this.type === "multipleSmallCards"
            };
        }
    }
};
